import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { massImportCrmProjectsWithConfigs } from ".";

export function useMassImportCrmProjectsWithConfigs(){
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: queryKeys.crm._def,
        mutationFn: massImportCrmProjectsWithConfigs,
        onSuccess: ()=>{
            queryClient.invalidateQueries({ queryKey: queryKeys.crm._def });
            queryClient.invalidateQueries({ queryKey: queryKeys.crm_project._def });
            queryClient.invalidateQueries({ queryKey: queryKeys.crm_config._def });
        }
    })
}